import React from 'react';

const Layout = ({ children }) => {
    return (
        <div className="fundisha-app-shell">
            {children}
        </div>
    );
};

export default Layout;